/*
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-07-14 17:00:21
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 14:06:05
 */

import { Math } from 'core-js'

/* eslint-disable */
var doublePI = Math.PI * 2
var canvas
var ctx
// 画布的高度的一半
var halfCanvasHeight = 80
// 衰减系数(越大, 边缘衰减的就越多, 震动宽度相应也越窄)
var attenuationCoefficient = 1.6
// 半波长个数-1
var halfWaveCount = 1.2
// 振幅是画布高度的一般的百分比[0,1]
var amplitudePercentage = 0.4
// 每帧增加的弧度[0,2PI](作用于sin曲线, 正值相当于原点右移, 曲线左移)
var radianStep = -0.12
// 当前弧度的偏移
var radianOffset = 0
// 画布宽度
var canvasWidth
var inited

function init(el) {
  canvas = el
  ctx = canvas.getContext('2d')
  canvasWidth = canvas.width
  canvas.height = halfCanvasHeight * 2
  if (inited) {
    return inited
  }
  loop()
  inited = true
}

// 设K=attenuationCoefficient, 计算信号衰减 (4K/(4K+x^4))^2K<=1 (x belong [-K,K])
function calcAttenuation(x, param) {
  return Math.pow(
    (4 * param.attenuationCoefficient) /
      (4 * param.attenuationCoefficient + Math.pow(x, 4)),
    2 * param.attenuationCoefficient
  )
}
// heightPercentage为振幅的显示比例
function drawAcousticWave(
  halfCanvasHeight,
  heightPercentage,
  color,
  alpha,
  lineWidth,
  param
) {
  ctx.strokeStyle = color
  ctx.globalAlpha = alpha
  ctx.lineWidth = lineWidth || 1
  ctx.beginPath()
  ctx.moveTo(0, halfCanvasHeight)
  var x, y
  for (
    var i = -param.attenuationCoefficient;
    i <= param.attenuationCoefficient;
    i += 0.01
  ) {
    // i是当前位置相对于整个长度的比率( x=width*(i+K)/(2*K))
    x =
      (canvasWidth * (i + param.attenuationCoefficient)) /
      (2 * param.attenuationCoefficient)
    // 加offset相当于把sin曲线向右平移
    y =
      halfCanvasHeight +
      halfCanvasHeight *
        param.amplitudePercentage *
        calcAttenuation(i, param) *
        heightPercentage *
        Math.sin(param.halfWaveCount * i + radianOffset)
    ctx.lineTo(x, y)
  }
  ctx.stroke()
}
function loop() {
  radianOffset = (radianOffset + radianStep) % doublePI
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  drawAcousticWave(80, 0.8, '#45D585', 0.4, 4, {
    attenuationCoefficient: 1.6,
    // 半波长个数-1
    halfWaveCount: 2.4,

    // 振幅是画布高度的一般的百分比[0,1]
    amplitudePercentage: 0.4,
    // 每帧增加的弧度[0,2PI](作用于sin曲线, 正值相当于原点右移, 曲线左移)
    radianStep: -0.12
  })
  drawAcousticWave(80, 0.8, '#45D585', 1, 4, {
    attenuationCoefficient: 1.6,
    // 半波长个数-1
    halfWaveCount: 1.8,

    // 振幅是画布高度的一般的百分比[0,1]
    amplitudePercentage: 0.6,
    // 每帧增加的弧度[0,2PI](作用于sin曲线, 正值相当于原点右移, 曲线左移)
    radianStep: -0.12
  })
  drawAcousticWave(80, 0.8, '#0CCA92', 0.2, 4, {
    attenuationCoefficient: 1.6,
    // 半波长个数-1
    halfWaveCount: 3,

    // 振幅是画布高度的一般的百分比[0,1]
    amplitudePercentage: 0.6,
    // 每帧增加的弧度[0,2PI](作用于sin曲线, 正值相当于原点右移, 曲线左移)
    radianStep: -0.12
  })
  requestAnimationFrame(loop)
}
export default {
  init: init
}
